export default function ComingSoonView() {
  return {
    view: function () {
      return [
        m(".text-center.mb-5.mt-5", [
          m(".icon-size.color-error", m("i.bi.bi-info-lg")),
          "Menu Coming Soon!!",
        ]),
      ];
    },
  };
}
